import apiEndPoints from 'common/apiEndPoints';
import { performRequestThird } from 'common/apiHandler';
import { getTenantDetails } from 'utils/utils';

//Api for validating automation rules and infinite looping of automation rules
export const validateAutomationRule = (params = {}) => {
  const [tenantId = '', tenantSk = ''] = getTenantDetails();
  const { data } = params || {};

  return performRequestThird(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.validateAutomationRule}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};
